import { Spinner } from 'components/Elements';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Landing } from 'features/misc';

const { AccountRoutes } = lazyImport(() => import('features/account'), 'AccountRoutes');
const { ProductRoutes } = lazyImport(() => import('features/products'), 'ProductRoutes');
const { BlogRoutes } = lazyImport(() => import('features/blog'), 'BlogRoutes');
const { OrdersRoutes } = lazyImport(() => import('features/orders'), 'OrdersRoutes');

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/my-account/*',
        element: <AccountRoutes />,
      },
      {
        path: '/products/*',
        element: <ProductRoutes />,
      },
      {
        path: '/orders/*',
        element: <OrdersRoutes />,
      },
      {
        path: '/blog/*',
        element: <BlogRoutes />,
      },
      { path: '/', element: <Landing /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
